module.exports = __webpack_public_path__ + "img/chevron-compact-right_secandary.bdb77a47.svg";